import {Injectable} from '@angular/core';
import {HttpService} from '../../common/_services/http.service';
import {Grievance, Item} from './_modals/grievance.modal';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AppResponse} from '../../common/_modals/app.response';
import {Observable} from 'rxjs';




@Injectable()
export class GrievanceService {
    value: string;
    public item_from_ui = {};
    public updatable_field_keys = ['id', 'transcript', 'reason_id', 'sm_image', 'detail',
                                    'rating',  'title', 'pub_order', 'tags', 'misc', 'state', 'dm_propeties'];

    constructor(private httpService: HttpService, private http: HttpClient) {}
    saveGrievance(itemRequest: Grievance, oldobj) {
        this.item_from_ui = {};
        for (let item of this.updatable_field_keys) {
            if (item === 'id' || oldobj[item] !== itemRequest[item]) {
                if (item === 'campaign_categories') {
                    if (oldobj[item].toString() !== itemRequest[item].toString())
                        this.item_from_ui[item] = itemRequest[item];
                } else this.item_from_ui[item] = itemRequest[item];
            }
        }
        return this.httpService.post('', this.item_from_ui, null, true);
    }

    getReasons(ai_id: number) {
        return this.httpService.get('mnews/reject_reason/?ai=' + ai_id + '&comment=false', null, true);
    }

    getGrievanceByNumber(ai_id: number, state_id: number, callerid: String) {
        // tslint:disable-next-line:max-line-length
        return this.httpService.get('casemanager/grievance/getGrievances/?ai_id=' + ai_id + '&state_id=' + state_id + '&callerid=' + callerid + '&format=json');
    }

    callContributor( handler: string, contributor: string) {
        let data = {schedule_id: 0, handler: '', beneficiary: ''};
        data.schedule_id = 506;
        data.handler = handler;
        data.beneficiary = contributor;
        return this.httpService.post('helpline/call/', data, null, false);
    }
    getHandler(ai_id: number): Observable<any> {
        return this.httpService.get<AppResponse>('casemanager/handler/getHandler/?ai_id=' + ai_id + '&format=json');
    }
    getQuitReason(ai_id: number): Observable<any> {
        // tslint:disable-next-line:max-line-length
        return this.httpService.get<AppResponse>('casemanager/grievance_quit_reason/getGrievanceQuitReason/?ai_id=' + ai_id + '&format=json');
    }
    updateGrievance(state: string, handler_id, grievance_id, quitreason_id) {
        return this.httpService.post(
            // tslint:disable-next-line:max-line-length
            'casemanager/grievance/update/?limit=1000&state=' + state + '&grievance_id=' + grievance_id + '&handler_id=' + handler_id + '&quitreason_id=' + quitreason_id,
            null ,
            null,
            false);
    }
}
